export enum StoreFilterForEnum {
  Filter = 'Filter',
  Result = 'Result'
}
